<div class="glxy-nav-submenu-trigger" [ngClass]="{ 'menu-open': expanded }">
  <mat-icon class="glxy-nav-arrow-icon">arrow_right</mat-icon>
  <button class="glxy-nav-item-link" matRipple (click)="toggle()">
    <div class="glxy-nav-item-layout">
      @if (icon && !isSvg) {
        <mat-icon>{{ icon }}</mat-icon>
      }
      @if (icon && isSvg) {
        <mat-icon [svgIcon]="icon" />
      }
      <div class="glxy-nav-item-truncate">
        <ng-content />
      </div>
      <ng-content select="glxy-nav-item-accessory" />
    </div>
  </button>
</div>
<div class="glxy-nav-submenu" [ngClass]="{ 'menu-open': expanded }" [@openClose]="expanded ? 'open' : 'closed'">
  <div class="glxy-nav-submenu-items">
    <ng-content select="glxy-nav-item-list-items" />
  </div>
</div>
